import { CartItem, Product } from '../../types/common';
import { SECOND_PILLOW_CATEGORY_URL, SECOND_PILLOW_MIN_PRICE } from './config';
import { isSeasonalSecondPillowActive } from './date';

export function getSecondPillowDiscountQtyById(cart: CartItem[], products: Product[], authUser: any, excludeIds?: Set<string>): Map<string, number> {
    const result = new Map<string, number>();
    if (!isSeasonalSecondPillowActive()) return result;
    if (!Array.isArray(cart) || !Array.isArray(products) || !cart.length || !products.length) return result;
    const isEmployee = authUser?.status === 'employee';
    const units: Array<{ productId: string; unitPrice: number; seq: number }> = [];
    let seq = 0;
    for (const c of cart) {
        const productId = String(c.productId || '').trim();
        if (!productId) continue;
        if (excludeIds?.has(productId)) continue; // не суммируем с 3+
        const p = products.find((pr) => pr.id === productId);
        if (!p) continue;
        const categoryUrl = String((p as any)?.category?.url || '')
            .trim()
            .toLowerCase();
        const groupUrl = String((p as any)?.group?.url || '')
            .trim()
            .toLowerCase();
        const prodCat = categoryUrl || groupUrl;
        if (!prodCat || prodCat !== SECOND_PILLOW_CATEGORY_URL) continue;
        const basePrice = typeof p.price === 'number' ? p.price : NaN;
        if (!Number.isFinite(basePrice) || basePrice < SECOND_PILLOW_MIN_PRICE) continue;
        const sp = (p as any).specialDiscount && typeof (p as any).specialDiscount.discountedPrice === 'number' ? (p as any).specialDiscount.discountedPrice : null;
        const dp = (p as any).discount && typeof (p as any).discount.discountedPrice === 'number' ? (p as any).discount.discountedPrice : null;
        const hasEmployeeSpecial = isEmployee && typeof sp === 'number';
        const hasRegularDiscount = typeof dp === 'number';
        // НЕ применяем акцию если уже есть скидка
        if (hasEmployeeSpecial || hasRegularDiscount) continue;
        const rawQty = Number(c.quantity);
        const qty = Number.isFinite(rawQty) && rawQty > 0 ? Math.floor(rawQty) : 1;
        if (qty <= 0) continue;
        for (let i = 0; i < qty; i++) {
            units.push({ productId, unitPrice: basePrice, seq: seq++ });
        }
    }
    const discountedUnitsCount = Math.floor(units.length / 2);
    if (discountedUnitsCount <= 0) return result;
    // чётная подушка: скидку получат самые дешёвые
    units.sort((a, b) => {
        if (a.unitPrice !== b.unitPrice) return a.unitPrice - b.unitPrice;
        return a.seq - b.seq;
    });
    for (let i = 0; i < discountedUnitsCount; i++) {
        const u = units[i];
        result.set(u.productId, (result.get(u.productId) || 0) + 1);
    }
    return result;
}
